import { Link } from 'react-router-dom';
import { Mail, MessageSquare, BookOpen, ShieldCheck } from 'lucide-react';
const supportLinks = [{
  icon: Mail,
  title: 'Email support',
  body: 'For help with Giga, your account, or the Slack integration.',
  href: 'mailto:support@getgiga.com',
  label: 'support@getgiga.com'
}, {
  icon: MessageSquare,
  title: 'Contact form',
  body: 'Send us product questions, support requests, or partnership notes.',
  href: '/contact',
  label: 'getgiga.com/contact',
  internal: true
}, {
  icon: BookOpen,
  title: 'Developer documentation',
  body: 'Review public API, OpenAPI, webhooks, and MCP resources.',
  href: '/developers',
  label: 'Developer resources',
  internal: true
}, {
  icon: ShieldCheck,
  title: 'Security reports',
  body: 'Report a vulnerability or security concern through our disclosure page.',
  href: '/vulnerability-disclosure',
  label: 'Vulnerability disclosure',
  internal: true
}];
export function Support() {
  return <div className="min-h-[80vh] bg-[#FAF8F4] px-6 pt-32 pb-24" data-id="element-11852" data-mp="1sejlldtxy7gc">
      <div className="mx-auto max-w-4xl" data-id="element-11853" data-mp="21vsvpqwh8dyy">
        <div className="max-w-2xl" data-id="element-11854" data-mp="1wy12mtk3ilt6">
          <p className="mb-4 text-sm font-bold uppercase tracking-[0.18em] text-[#EA580C]" data-id="element-11855" data-mp="1wxr7yso3vqh5">
            Giga support
          </p>
          <h1 className="font-title text-4xl font-bold tracking-tight text-[#2B211A] md:text-5xl" data-id="element-11856" data-mp="1rx39jlxjs7cw">
            Need Help?
          </h1>
          <p className="mt-5 text-lg leading-8 text-neutral-600" data-id="element-11857" data-mp="1iy9kcgmjqj9d">
            If you&apos;re having trouble with Giga or our Slack integration,
            we&apos;re here to help. Email us directly or use the contact form
            below.
          </p>
        </div>

        <div className="mt-10 rounded-2xl border border-[#EAE4D9] bg-white p-6 shadow-[0_12px_36px_-28px_rgba(43,33,26,0.45)] md:p-8" data-id="element-11858" data-mp="198q139ux8ndz">
          <div className="grid gap-6 md:grid-cols-2" data-id="element-11859" data-mp="za0pfytmbz66">
            {supportLinks.map(item => {
            const Icon = item.icon;
            const content = <>
                  <span className="flex size-11 shrink-0 items-center justify-center rounded-xl bg-[#EA580C]/10 text-[#EA580C]" data-id="element-11860" data-mp="varw2v2hq3b5">
                    <Icon size={20} data-id="element-11861" data-mp="pmep50so0xzu" />
                  </span>
                  <span data-id="element-11862" data-mp="pny14f7agmvt">
                    <span className="block font-title text-xl font-semibold tracking-tight text-[#2B211A]" data-id="element-11863" data-mp="bmvhe93rnoo2">
                      {item.title}
                    </span>
                    <span className="mt-1 block text-sm leading-6 text-neutral-500" data-id="element-11864" data-mp="gm8cti8pe429">
                      {item.body}
                    </span>
                    <span className="mt-3 block font-semibold text-[#EA580C]" data-id="element-11865" data-mp="18dnvj17536n7">
                      {item.label}
                    </span>
                  </span>
                </>;
            return item.internal ? <Link key={item.title} to={item.href} className="flex gap-4 rounded-xl border border-[#EAE4D9] p-5 transition-colors hover:border-[#EA580C]/40 hover:bg-[#FFF4EC]" data-id="element-11866" data-mp="zkaz3p9v9mwd">
                  {content}
                </Link> : <a key={item.title} href={item.href} className="flex gap-4 rounded-xl border border-[#EAE4D9] p-5 transition-colors hover:border-[#EA580C]/40 hover:bg-[#FFF4EC]" data-id="element-11867" data-mp="1s26prx705a8r">
                  {content}
                </a>;
          })}
          </div>

          <div className="mt-8 rounded-xl bg-[#FAF8F4] px-5 py-4 text-neutral-700" data-id="element-11868" data-mp="2b5qq9yzaret6">
            <p className="font-semibold text-[#2B211A]" data-id="element-11869" data-mp="2b7upi3m93pn4">Expected response time</p>
            <p className="mt-1 leading-7" data-id="element-11870" data-mp="267fgtpcwz6bh">
              We aim to respond to support requests within 1-2 business days.
            </p>
          </div>
        </div>
      </div>
    </div>;
}